import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { BETON_FEATURE, BetonState, StateWithBeton } from '../beton-state';

export const getBetonState: MemoizedSelector<StateWithBeton, BetonState> = createFeatureSelector(BETON_FEATURE);
